import { RefundRequest } from "./refund-request";
import { PaymentDetailByPaymentJSON } from "./payment-summary";
import { TaxRateLiterals } from "@graffer-inc/cloud-gov-core";

export class RefundRequestFactory {
  static createFromPaymentSummary(
    payment: PaymentDetailByPaymentJSON,
  ): RefundRequest {
    return new RefundRequest({
      items: payment.invoice.items.map((v) => ({
        refundableAmount: v.refundableAmount,
        taxRate: v.taxRate as TaxRateLiterals,
        description: v.description,
        refundAmount: v.refundableAmount,
      })),
      message: "",
    });
  }

  static createDefaultFromSummary(
    payment: PaymentDetailByPaymentJSON,
  ): RefundRequest {
    return new RefundRequest({
      items: payment.invoice.items.map((v) => ({
        refundableAmount: v.refundableAmount,
        taxRate: v.taxRate as TaxRateLiterals,
        description: v.description,
        refundAmount: 0,
      })),
      message: "",
    });
  }
}
